/**
 * Removes thousands separators from a string.
 *
 * @param {string} value - The number as a string with thousands separators.
 * @returns {string} The number string without thousands separators, or the original string if it doesn't appear to be a valid number format.
 *
 * @example
 * removeThousandsSeparator('694,201,010.123456');
 * // Returns '694201010.123456'
 */
const removeThousandsSeparator = (value: string): string =>
  value.replace(/,/g, '');

export default removeThousandsSeparator;
